import React from 'react'
import Bg2 from '../Components/Services/Images/seo/bg2.png';
import posSystem from '../Components/ProductSlider/Images/pos.png';
import { Link } from 'react-router-dom';
import BenifitIcon1 from '../Pages/assets/benifits-pos-1.svg'
import BenifitIcon2 from '../Pages/assets/benifits-pos-2.svg'
import BenifitIcon3 from '../Pages/assets/benifits-pos-3.svg'
import BenifitIcon4 from '../Pages/assets/benifits-pos-4.svg'

import categoriesBg from '../Pages/assets/8h2.png'

import categoryIcon1 from '../Pages/assets/pos-categories/ss1.svg'
import categoryIcon2 from '../Pages/assets/pos-categories/ss2.svg'
import categoryIcon3 from '../Pages/assets/pos-categories/ss3.svg'
import categoryIcon4 from '../Pages/assets/pos-categories/ss4.svg'
import categoryIcon5 from '../Pages/assets/pos-categories/ss5.svg'
import categoryIcon6 from '../Pages/assets/pos-categories/ss6.svg'
import categoryIcon7 from '../Pages/assets/pos-categories/ss7.svg'
import categoryIcon8 from '../Pages/assets/pos-categories/ss8.svg'
import categoryIcon9 from '../Pages/assets/pos-categories/ss9.svg'
import categoryIcon10 from '../Pages/assets/pos-categories/ss10.svg'
import InnerArea from '../Components/InnerArea/InnerArea';
import ProductTestimonials from '../Components/Testimonial/ProductTestimonials/ProductTestimonials';
import shopItem from '../Pages/assets/shop.png'


function PosSoftware() {

    // banner 
    const content = {
        title: "Grow your retail faster with FusionHub",
        titleSpan: "POS software",
        description: "",
        img: posSystem
    };

    // services 
    const services = [
        {
            icon: BenifitIcon1,
            title: 'Save Time',
            description: 'Everyday save your time 1/2 hours that our system automates manage',
        },
        {
            icon: BenifitIcon2,
            title: 'Increase Sales',
            description: 'Our user friendly speeds up checkout and increase sales your business',
        },
        {
            icon: BenifitIcon3,
            title: 'Make Info Decisions',
            description: 'Order the right products for you store using our reporting',
        },
        {
            icon: BenifitIcon4,
            title: 'Access your data',
            description: 'Access your data anytime anywhere for your security issue.',
        },
    ];

    // categories 
    const categories = [
        { icon: categoryIcon1, title: 'Restaurent' },
        { icon: categoryIcon2, title: 'Mega Shop' },
        { icon: categoryIcon3, title: 'Handicraft' },
        { icon: categoryIcon4, title: 'Home Appliance' },
        { icon: categoryIcon5, title: 'Hospital' },
        { icon: categoryIcon6, title: 'Dispensary' },
        { icon: categoryIcon7, title: 'Sports & Outdoors' },
        { icon: categoryIcon8, title: 'Beauty Product' },
        { icon: categoryIcon9, title: 'Storage' },
        { icon: categoryIcon10, title: 'Toy & Hobbies' },
    ];

    // shop 
    const shopItems = [
        {
            id: 1,
            image: shopItem,
            isNew: false,
            name: "Mobile POS Systems",
            price: 160,
            discountedPrice: 190
        },
        {
            id: 2,
            image: shopItem,
            isNew: true,
            name: "Stationary POS Systems",
            price: 160,
            discountedPrice: 190
        },
    ];

    return (
        <>
            <div className="header-area h8-banner-area h8-banner-area-bg mg-top-50">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 offset-xl-1">
                            <div className="header-inner-details">
                                <div className="header-inner">
                                    <h1 className="title wow animated fadeInUp" data-wow-duration="1s" data-wow-delay="0s">{content.title} <span>{content.titleSpan}</span></h1>
                                    <p className="wow animated fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">{content.description}</p>
                                    <div className="btn-wrapper desktop-left padding-top-20 wow animated fadeInUp" data-wow-duration="1s" data-wow-delay="0.6s">
                                        <Link href="#" className="btn btn-radius btn-red-border mr-2 mb-2">Start Free trial</Link>
                                        <Link href="#" className="btn btn-radius btn-red mb-2">Get Premium</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-5 hidden-sm">
                            <div className="banner-animate-thumb banner-animate-thumb-2">
                                <div className="header-img-1 wow animated fadeInRight" data-wow-duration="1s" data-wow-delay="0s">
                                    <img src={Bg2} alt="banner-img" />
                                </div>
                                <div className="header-img-2 wow animated fadeInDown" data-wow-duration="1s" data-wow-delay="0.5s">
                                    <img src={content.img} alt="banner-img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-area sbtc-service-area pd-top-30">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-9">
                            <div className="section-title text-center">
                                <h2 className="title pb-2"><span>Benefits</span> of Point of Sale</h2>
                                <p className="pb-3">Guaranteed to save you time, increase the accuracy of your inventory, and help you make informed decisions for your business</p>
                            </div>
                        </div>
                    </div>
                    <div className="row custom-gutters-16 justify-content-center">
                        {services.map((service, index) => (
                            <div key={index} className="col-xl-3 col-lg-6 col-sm-6">
                                <div className="single-service-2 style-two text-center">
                                    <div className="thumb">
                                        <img src={service.icon} alt="service" />
                                    </div>
                                    <h6>{service.title}</h6>
                                    <p>{service.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="software-store-area mg-top-100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center pb-4">
                                <h2 className="title">Perfect POS software for most <span>retail stores</span></h2>
                                <p>Perfect POS software for most retail stores. Access and manage your books from FusionHub.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bg-after pd-top-120 pd-bottom-90 jarallax" style={{ backgroundImage: `url(${categoriesBg})` }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xl-11">
                                <ul className="software-store-wrap">
                                    {categories.map((category, index) => (
                                        <li key={index}>
                                            <a href="#" className="single-software-store text-center">
                                                <div className="thumb">
                                                    <img src={category.icon} alt="img" />
                                                </div>
                                                <h4>{category.title}</h4>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <InnerArea />

            <div className="shop-area mg-top-110">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-9">
                            <div className="section-title style-two text-center">
                                <h2 className="title">We are selling <span>POS Device</span></h2>
                                <p>Our support team will get assistance from AI-powered suggestions, making it quicker than ever to support requests. Our support team will get from AI-powered suggestions.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row custom-gutters-16">
                        {/* Map through shopItems array */}
                        {shopItems.map(item => (
                            <div key={item.id} className="col-lg-3 col-sm-6">
                                <div className="single-shop style-two">
                                    <div className="thumb">
                                        {item.isNew && <a className="product-badge btn-blue" href="#">New</a>}
                                        <img src={item.image} alt="shop" />
                                        <div className="cart-btn">
                                            <div className="cart-btn-wrap">
                                                <a className="btn btn-red" href="#">Add to cart <i className="fa fa-shopping-cart"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="content">
                                        <div className="rating">
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                            <i className="fa fa-star"></i>
                                        </div>
                                        <a href="#">{item.name}</a>
                                        <div className="price">
                                            <span>${item.price}.00</span><del>${item.discountedPrice}.00</del>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <ProductTestimonials />
        </>
    )
}

export default PosSoftware